export default "__VITE_ASSET__DyjkzydW__"